import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'
import { useAuthorization } from '~/hooks/useAuthorization'
import { useLogEvent } from '~/hooks/useLogEvent'
import { useNotify } from '~/hooks/useNotify'

import { type InputValues } from '../utils'

export const DocumentReportDownloadButton = () => {
  const { t } = useTranslation()
  const { getValues } = useFormContext<InputValues>()
  const getAuthorization = useAuthorization()
  const logEvent = useLogEvent()
  const notify = useNotify()
  const [isExporting, setIsExporting] = React.useState(false)

  const handleClick = React.useCallback<
    EH<IconButtonProps, 'onClick'>
  >(async () => {
    setIsExporting(true)
    try {
      const content = getValues('content')
      const title = getValues('title') || 'document'
      const { exportDocumentAsZip } = await import('../exportDocumentAsZip')
      await exportDocumentAsZip(content, title, getAuthorization)
      logEvent('Download document as markdown')
    } catch (error) {
      console.error('Document export failed:', error)
      notify({ content: t('document_download_failed'), style: 'error' })
    } finally {
      setIsExporting(false)
    }
  }, [getAuthorization, getValues, logEvent, notify, t])

  return (
    <IconButton
      disabled={isExporting}
      fillMode="outline"
      icon="download"
      onClick={handleClick}
    />
  )
}
